import MButton from "./MButton.vue";
export default MButton;
